import React, { useCallback, useEffect, useState } from 'react';
import { supabase } from './supabaseClient';
import { t, getLocale } from './i18n';

// ============================================================
// Cheia Claude a clientului (15 octombrie 2026).
//
// Hotararile Luminitei: o pune ea sau clientul insusi; pe cheia lui merge TOT ce face AI-ul pentru
// el, platit de el direct la Anthropic; cheia lui cazuta NU se inlocuieste pe tacute cu a New Mind.
// Cheia nu se vede niciodata intreaga: o primeste functia `cheie-ai`, o verifica la Anthropic si o
// pastreaza unde doar serverul o citeste. Pe ecran: sfarsitul ei, cand a fost verificata, si eroarea.
// Managerul nu vede caseta (politica tabelului `chei_ai_clienti` nu-i da nimic).
// ============================================================

async function detaliu(error) {
  try {
    const ctx = error && error.context;
    if (ctx && typeof ctx.json === 'function') { const c = await ctx.json(); return String(c.detail || c.error || error.message); }
  } catch (_e) { /* mai jos */ }
  return (error && error.message) || '';
}

export function CheieClaude({ clientId, rol: rolDat = null }) {
  // Fara rol dat (pagina clientului e si a managerului): il aflam. Doar super adminul si clientul.
  const [rol, setRol] = useState(rolDat);
  useEffect(() => {
    if (rolDat) return;
    supabase.rpc('este_super_admin').then(r => setRol(r.data ? 'super_admin' : 'altul'), () => setRol('altul'));
  }, [rolDat]);
  const [stare, setStare] = useState(null);       // null = se incarca; {} = fara cheie
  const [cheie, setCheie] = useState('');
  const [lucrez, setLucrez] = useState(false);
  const [mesaj, setMesaj] = useState('');

  const incarca = useCallback(async () => {
    const { data } = await supabase.from('chei_ai_clienti')
      .select('sfarsit, adaugata_la, verificata_la, eroare, eroare_la').eq('client_id', clientId).maybeSingle();
    setStare(data || {});
  }, [clientId]);
  useEffect(() => { setMesaj(''); setCheie(''); incarca(); }, [incarca]);

  if (rol !== 'super_admin' && rol !== 'client') return null;
  if (stare === null) return null;

  async function pune() {
    if (!cheie.trim()) return;
    setLucrez(true); setMesaj('');
    const { error } = await supabase.functions.invoke('cheie-ai', { body: { client_id: clientId, actiune: 'pune', cheie: cheie.trim() } });
    setLucrez(false);
    if (error) { setMesaj(t('cheieClaude', 'respinsa', { eroare: await detaliu(error) })); return; }
    setCheie('');
    setMesaj(t('cheieClaude', 'pusa'));
    await incarca();
  }
  async function scoate() {
    if (!window.confirm(t('cheieClaude', 'confirmScoate'))) return;
    setLucrez(true);
    const { error } = await supabase.functions.invoke('cheie-ai', { body: { client_id: clientId, actiune: 'scoate' } });
    setLucrez(false);
    if (error) { setMesaj(t('cheieClaude', 'respinsa', { eroare: await detaliu(error) })); return; }
    setMesaj(t('cheieClaude', 'scoasa'));
    await incarca();
  }

  const data = (iso) => (iso ? new Date(iso).toLocaleString(getLocale(), { timeZone: 'Europe/Bucharest', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '');
  const areCheie = !!stare.sfarsit;
  const camp = { flex: 1, minWidth: 220, padding: '8px 10px', borderRadius: 8, border: '1.5px solid #D1E8DA', fontSize: 14, fontFamily: 'monospace' };

  return (
    <div style={{ background: 'white', border: '1.5px solid ' + (stare.eroare ? '#B42318' : '#D1E8DA'), borderRadius: 12, padding: 16, margin: '0 0 16px' }}>
      <div style={{ fontSize: 15, fontWeight: 600, color: '#0F3D22', marginBottom: 4 }}>{t('cheieClaude', 'titlu')}</div>
      <div style={{ fontSize: 13, color: '#374151', marginBottom: 10 }}>
        {areCheie ? t('cheieClaude', 'cuCheie', { sfarsit: stare.sfarsit, data: data(stare.verificata_la || stare.adaugata_la) }) : t('cheieClaude', 'faraCheie')}
      </div>
      {stare.eroare && (
        <div style={{ background: '#FDECEA', borderRadius: 8, padding: '8px 10px', fontSize: 13, color: '#1F2937', marginBottom: 10 }}>
          {t('cheieClaude', 'cazuta', { data: data(stare.eroare_la), eroare: stare.eroare })}
        </div>
      )}
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'center' }}>
        <input type="password" autoComplete="off" value={cheie} onChange={e => setCheie(e.target.value)}
          placeholder={areCheie ? t('cheieClaude', 'altaCheie') : 'sk-ant-…'} style={camp} />
        <button type="button" className="btn-principal" disabled={lucrez || !cheie.trim()} onClick={pune}>
          {lucrez ? t('cheieClaude', 'verific') : t('cheieClaude', 'leaga')}
        </button>
        {areCheie && <button type="button" className="btn-secundar" disabled={lucrez} onClick={scoate}>{t('cheieClaude', 'scoate')}</button>}
      </div>
      {mesaj && <div style={{ fontSize: 13, color: '#1A6B3C', marginTop: 8 }} role="status">{mesaj}</div>}
      <div style={{ fontSize: 12, color: '#4B5563', marginTop: 8 }}>{t('cheieClaude', 'explicatie')}</div>
    </div>
  );
}
